/**
 * Tutorial guidato dei Listini.
 *
 * Il piu' in alto si racconta illuminando il pulsante e non la voce dentro il menu:
 * un menu di Vuetify aperto dal tutorial si richiude da solo, perche' il click
 * programmatico e quello su "Avanti" arrivano a `document` a un soffio di distanza.
 */
const SCOPE = '[data-tour-scope="setting-listings"]';

const at = name => `${SCOPE} [data-tour="${name}"]`;

export function createListingsTourSteps() {
	return [
		{
			body: "Un listino e' un prezzo diverso per lo stesso catalogo: lo sconto riservato a un gruppo di clienti, il prezzo per i rivenditori, la tariffa di un canale. Il catalogo resta uno solo - cambia quanto costa a chi.",
			key: 'intro',
			placement: 'bottom',
			target: at('tutorial'),
			title: 'I listini',
		},
		{
			body: "Il piu' in alto apre la voce Aggiungi listino: si da' un nome e la percentuale di sconto rispetto al prezzo di base, e poi si assegna il listino ai clienti che devono averlo.",
			key: 'add',
			placement: 'left',
			target: at('add'),
			title: 'Aggiungere un listino',
		},
		{ body: "La lente apre i filtri sulla destra, per restringere l'elenco quando i listini diventano molti.", key: 'filters', placement: 'left', target: at('filters'), title: 'Filtrare l’elenco' },
		{
			body: "La tabella mostra lo stato, il nome, lo sconto in percentuale e quanti prodotti sono coinvolti. Lo sconto si applica sul prezzo di listino del prodotto: non e' un prezzo scritto a mano, e' una regola.",
			key: 'table',
			placement: 'top',
			target: at('table'),
			title: 'Leggere l’elenco',
		},
		{
			body: "L'interruttore accende e spegne il listino, e salva subito. Spento, i clienti che lo avevano assegnato tornano a vedere il prezzo di base senza che tu debba toccare le loro schede.",
			key: 'switch',
			missing: 'skip',
			placement: 'right',
			target: at('switch'),
			timeout: 250,
			title: 'Accendere un listino',
		},
	];
}
